<template>
  <div>
    <!-- <b-button variant="warning" size="sm" @click.prevent="thread = shipping.threads.find(x => x.type === 'incidence')" v-b-modal="'modalShippingThread-' + rand" v-if="shipping.threads && shipping.threads.findIndex(x => x.type === 'incidence') !== -1">
      <font-awesome-icon icon="comment" size="2x" style="font-size: 16px; vertical-align: middle" />
    </b-button> -->

    <b-modal size="lg" :id="'modalShippingThread-' + rand" :ref="'modalShippingThread-' + rand" @hidden="thread = {}" hide-footer>
      <template #modal-title>
        <translate>Shipment Message Thread</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <shipping-message-threads :the-thread="thread" v-if="thread" no-subject />
    </b-modal>
  </div>
</template>

<script>
import ShippingMessageThreads from '@/components/Shippings/MessageThreads'

export default {
  name: 'MessageThreadsIcon',
  components: {
    ShippingMessageThreads
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      thread: {},
      rand: Math.floor(Math.random() * 100000)
    }
  }
}
</script>
